import * as HttpService from '../../HttpService'

let namespace = 'https://api.nrpladetjek.dk/api/lookups'

let plate = (options, cb, errorCb) => {
    HttpService.get(namespace + '/plate', options, cb, errorCb)
}

let wanted = (options, cb, errorCb) => {
    HttpService.get(namespace + '/wanted', options, cb, errorCb)
}

let dmr = (options, cb, errorCb) => {
    HttpService.get(namespace + '/dmr', options, cb, errorCb)
}

let registry = (options, cb, errorCb) => {
    HttpService.get(namespace + '/registry', options, cb, errorCb)
}

let inspection = (options, cb, errorCb) => {
    HttpService.get(namespace + '/inspection', options, cb, errorCb)
}

let latest = (options, cb, errorCb) => {
    HttpService.get(namespace + '/latest', options, cb, errorCb)
}

let countVehicle = (options, cb, errorCb) => {
    HttpService.get(namespace + '/vehicle-count', options, cb, errorCb)
}

let postLookup = (body, cb, errorCb) => {
    HttpService.post(namespace, body, cb, errorCb)
}

export {
    plate,
    wanted,
    dmr,
    registry,
    inspection,
    latest,
    countVehicle,
    postLookup
}



// WEBPACK FOOTER //
// ./src/services/api/lookup/lookupService.js